import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheckCircle as farCheckCircle, faTimesCircle, faAddressCard as farAddressCard } from '@fortawesome/free-regular-svg-icons';
import {
    faBan,
    faBuilding,
    faCalendarAlt,
    faCertificate,
    faCheckCircle,
    faEdit,
    faPlus,
    faSort,
    faSortDown,
    faSortUp,
    faTachometerAlt,
    faUsers,
    faUsersCog,
    faUserTag,
    faChartBar,
    faFileSignature,
    faBell,
    faCheck,
    faChevronUp,
    faChevronDown,
    faTrash,
    faUndo,
    faSave,
    faArrowCircleRight,
    faExclamation,
    faExchangeAlt,
    faClipboardList,
    faBars,
    faPen,
    faUserCheck,
    faUserTimes,
    faUserSlash,
    faUserMinus,
    faUser,
    faEnvelope,
    faEnvelopeOpen,
    faWineGlassAlt,
    faUserPlus,
    faWineBottle,
    faBalanceScale,
    faMinus,
    faSignInAlt,
    faEuroSign,
    faArrowLeft,
    faCubes,
    faKey,
    faSearch,
    faEllipsisH,
    faMinusCircle,
    faInfoCircle,
    faTimes,
    faDownload,
    faUserCircle,
    faAt,
    faLock,
    faClipboardCheck,
    faCopy,
    faAddressBook,
    faCog,
    faChevronRight,
    faMapMarkedAlt,
    faCoins,
    faFolderOpen,
    faFileAlt,
    faCalendar,
    faFileContract,
    faAppleAlt,
    faChartLine,
    faIdCard,
    faCommentDots,
    faFilter,
    faPlusSquare,
    faArrowRight,
    faPencilAlt,
    faTrashAlt,
    faCogs,
    faLeaf,
    faUpload,
    faList,
    faIdCardAlt,
    faHammer,
    faChevronLeft,
    faExclamationTriangle,
    faFolder,
    faArchive,
    faMedal,
    faDivide,
    faEye,
    faSortNumericDown,
    faColumns,
    faFileExport,
    faTasks,
    faEraser,
    faTable,
    faHistory, 
    faSlidersH,
    faGripVertical
} from '@fortawesome/free-solid-svg-icons';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { LanguageDropdownComponent } from 'src/app/shared/components/language-dropdown/language-dropdown.component';
import { HasRoleDirective } from './directives/has-role/has-role.directive';
import { FilterPipe } from './pipes/filter/filter.pipe';
import { OrderByPipe } from './pipes/order-by/order-by.pipe';
import { MultiselectComponent } from './components/multiselect/multiselect.component';
import { HasHabilitationDirective } from './directives/has-habilitation/has-habilitation.directive';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { PaginationBarComponent } from './components/pagination-bar/pagination-bar.component';
import { TruncatePipe } from './pipes/truncate/truncate.pipe';
import { PhoneFormatPipe } from './pipes/phoneFormat/phone-format-pipe';
import { HasDomaineDirective } from './directives/has-domaine/has-domaine.directive';
import { SaisieRecolteFormatPipe } from './pipes/saisieRecolteFormat/saisie-recolte-format.pipe';
import { SearchAdherentActifBarComponent } from './components/search-entreprise/search-adherent-actif-bar/search-adherent-actif-bar.component';
import { SearchProducteurOrganiseBarComponent } from './components/search-entreprise/search-producteur-organise-bar/search-producteur-organise-bar.component';
import { SortableDirective } from './directives/sortable/sortable.directive';
import { SearchEntrepriseCategorieBarComponent } from './components/search-entreprise/search-entreprise-categorie-bar/search-entreprise-categorie-bar.component';
import { SearchIntervenantOrganismeBarComponent } from './components/search-intervenant/search-intervenant-organisme-bar/search-intervenant-organisme-bar.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { ConfirmationModalComponent } from 'src/app/shared/components/modals/confirmation-modal/confirmation-modal.component';

@NgModule({
    declarations: [
        LanguageDropdownComponent,
        FilterPipe,
        OrderByPipe,
        MultiselectComponent,
        SearchBarComponent,
        PaginationBarComponent,
        TruncatePipe,
        PhoneFormatPipe,
        SaisieRecolteFormatPipe,
        SearchAdherentActifBarComponent,
        SearchProducteurOrganiseBarComponent,
        SortableDirective,
        SearchEntrepriseCategorieBarComponent,
        SearchIntervenantOrganismeBarComponent,
        ConfirmationModalComponent
    ],
    exports: [
        CommonModule,
        TranslateModule,
        FontAwesomeModule,
        FormsModule,
        LanguageDropdownComponent,
        NgbModule,
        ReactiveFormsModule,
        HasRoleDirective,
        NgSelectModule,
        FilterPipe,
        OrderByPipe,
        TruncatePipe,
        MultiselectComponent,
        DragDropModule,
        HasHabilitationDirective,
        SearchBarComponent,
        PaginationBarComponent,
        PhoneFormatPipe,
        HasDomaineDirective,
        SaisieRecolteFormatPipe,
        SearchAdherentActifBarComponent,
        SearchProducteurOrganiseBarComponent,
        SearchEntrepriseCategorieBarComponent,
        SearchIntervenantOrganismeBarComponent,
        SortableDirective,
        ConfirmationModalComponent,
        CapitalizePipe
    ],
    imports: [
        TranslateModule,
        CommonModule,
        FontAwesomeModule,
        FormsModule,
        NgbModule,
        ReactiveFormsModule,
        NgSelectModule,
        DragDropModule,
        HasRoleDirective,
        HasHabilitationDirective,
        HasDomaineDirective,
        CapitalizePipe
    ]
})
export class SharedModule {
    constructor(library: FaIconLibrary) {
        library.addIcons(
            faTachometerAlt,
            faCalendarAlt,
            faCertificate,
            faPlus,
            faPlusSquare,
            faMinus,
            faMinusCircle,
            faBan,
            faCheckCircle,
            farCheckCircle,
            faUsersCog,
            faBuilding,
            faSortUp,
            faSortDown,
            faSort,
            faEdit,
            faUsers,
            faUserTag,
            faChartBar,
            faFileSignature,
            faBell,
            faCheck,
            faChevronDown,
            faChevronUp,
            faTrash,
            faUndo,
            faSave,
            faArrowCircleRight,
            faExclamation,
            faExchangeAlt,
            faClipboardList,
            faBars,
            faPen,
            faEnvelopeOpen,
            faEnvelope,
            faUserCheck,
            faUserTimes,
            faUserSlash,
            faUserMinus,
            faUserPlus,
            faUser,
            faWineGlassAlt,
            faWineBottle,
            faBalanceScale,
            faSignInAlt,
            faEuroSign,
            faArrowLeft,
            faCubes,
            faKey,
            faSearch,
            faEllipsisH,
            faInfoCircle,
            faTimesCircle,
            faTimes,
            faDownload,
            faUserCircle,
            faAt,
            faLock,
            faClipboardCheck,
            faCopy,
            faAddressBook,
            faCog,
            faChevronRight,
            faMapMarkedAlt,
            faCoins,
            faFileAlt,
            faFolderOpen,
            faCalendar,
            faFileContract,
            faHammer,
            faList,
            faIdCardAlt,
            faIdCard,
            faUpload,
            faAppleAlt,
            faCommentDots,
            faFilter,
            faCogs,
            faArrowRight,
            faPencilAlt,
            faTrashAlt,
            faLeaf,
            faChartLine,
            faChevronLeft,
            faExclamationTriangle,
            faMedal,
            faFolder,
            faArchive,
            faDivide,
            faEye,
            faSortNumericDown,
            faColumns,
            faFileExport,
            farAddressCard,
            faTasks,
            faEraser,
            faTable,
            faHistory,
            faSlidersH,
            faGripVertical
        );
    }
}
